export const CATEGORIES = [
    "Tutte",
    "Emozioni e consapevolezza",
    "Ansia e attacchi di panico",
    "Crescita personale",
    "Attualità e consapevolezza",
    "Relazioni e coppia",
    "Sessualità",
    "Ipnosi e metafore",
    'Dal libro "Prima di pensare"',
];

export const SITE_URL = "https://psicologogiovannidelorenzo.it";

export const ARTICLES = [
    {
        slug: "il-rumore-e-il-silenzio",
        title: "Il rumore e il silenzio",
        description: "Ciò che viene mostrato di continuo orienta la nostra attenzione. Una riflessione su come vengono raccontate proteste e manifestazioni, e su come la paura condiziona il nostro giudizio.",
        category: "Attualità e consapevolezza",
        date: "2026-10-28",
        image: "/images/10-rumore-silenzio.jpg",
        imageAlt: "Il rumore e il silenzio – riflessione del Dott. Giovanni De Lorenzo",
        quote: {
            text: "Chi controlla il racconto, spesso orienta anche il giudizio.",
            author: "Giovanni De Lorenzo",
        },
        sections: [
            {
                subtitle: null,
                paragraphs: [
                    "Mi capita di osservare quello che succede intorno a noi e avere la sensazione che, a forza di ascoltare le stesse notizie, si finisca per accettare tutto, anche ciò che meriterebbe una domanda in più.",
                ],
            },
            {
                subtitle: "Ciò che viene mostrato",
                paragraphs: [
                    "La comunicazione ha un grande potere, perché orienta la nostra attenzione. Ciò che viene mostrato continuamente acquista importanza, mentre quello che resta ai margini rischia di scomparire dai nostri pensieri.",
                ],
            },
            {
                subtitle: "Quando il racconto cambia",
                paragraphs: [
                    "In questi giorni, di fronte a scioperi e manifestazioni sempre più partecipate, mi colpisce un meccanismo. Per molto tempo certe proteste ricevono poca attenzione, poi, quando diventano più ampie e visibili, il racconto si sposta sugli episodi di disordine, sui gruppi più rumorosi, sulle immagini capaci di suscitare paura e indignazione.",
                    "Così, una manifestazione di migliaia di persone rischia di essere raccontata attraverso il comportamento di poche decine di approfittatori delinquenti.",
                    "Il dissenso, le ragioni della protesta, le richieste dei cittadini passano in secondo piano e al centro finiscono le vetrine danneggiate, gli scontri, il pericolo da cui proteggersi.",
                ],
            },
            {
                subtitle: "Le giuste proporzioni",
                paragraphs: [
                    "Gli episodi di violenza vanno raccontati e verificati, naturalmente, ma raccontare un fatto significa anche restituirgli le giuste proporzioni, distinguere le responsabilità e dare voce alle ragioni di chi manifesta.",
                    "Quando l'attenzione si concentra soltanto su una parte, il pubblico finisce per confondere il comportamento di pochi con quello di tutti.",
                ],
            },
            {
                subtitle: "Cosa succede dentro di noi",
                paragraphs: [
                    "Dal punto di vista psicologico, questo meccanismo ha un effetto preciso. Le immagini che suscitano paura restano impresse più facilmente, condizionano il giudizio e possono portarci a reagire prima ancora di aver compreso. A quel punto il pensiero si restringe e diventa più facile aderire a una versione dei fatti che cercare di capire cosa stia accadendo.",
                ],
            },
            {
                subtitle: "Prendere consapevolezza",
                paragraphs: [
                    "Prendere consapevolezza ci aiuta a fermarci prima di aderire a un giudizio, a chiederci chi sta parlando, quali fatti vengono raccontati e quali restano fuori dall'inquadratura e soprattutto cosa vogliono che ci arrivi.",
                    "Anche il piccolo gruppo che compie atti violenti esiste e va considerato per quello che fa, ma la sua presenza non può diventare il racconto di un'intera protesta.",
                    "Per cui possiamo manifestare il nostro dissenso, sostenere ciò in cui crediamo e riconoscere anche ciò che ci mette in discussione.",
                    "Sicuramente varrà la pena chiedersi quali fatti meritino davvero il nostro sguardo e quali, invece, finiscano per distoglierci da ciò che conta.",
                ],
            },
        ],
    },
    {
        slug: "anticipazioni-silenziose",
        title: "Anticipazioni silenziose",
        description: "Un messaggio che ci agita, una telefonata rimandata: il corpo registra ciò che accade prima della mente. Imparare a dire \"sto sentendo qualcosa\" prima di \"devo fare qualcosa\".",
        category: "Emozioni e consapevolezza",
        date: "2026-10-01",
        image: "/images/09-anticipazioni.jpg",
        imageAlt: "Donna pensierosa al tramonto con una figura luminosa alle spalle e un telefono sul tavolo — articolo sulle emozioni anticipate dal corpo",
        quote: {
            text: "Il corpo non mente mai.",
            author: "Agostino d'Ippona",
        },
        sections: [
            {
                subtitle: null,
                paragraphs: [
                    "A volte ci capita di ricevere un messaggio WhatsApp e sentire subito un certo fastidio.",
                    "Magari leggiamo una frase che interpretiamo come una critica, magari una provocazione o una mancanza di rispetto, e prima ancora di decidere cosa rispondere, sentiamo la tensione salire.",
                    "Oppure ci succede di pensare a quella telefonata che dobbiamo fare da tempo e continuiamo a rimandarla, e troviamo altro da fare, dicendoci che la faremo più tardi e intanto sentiamo una certa agitazione dentro, anche se facciamo fatica a capire da dove arrivi.",
                    "Sono situazioni molto comuni, che possono succedere quotidianamente, e ogni volta che succede il corpo registra quello che sta succedendo prima che la mente riesca a metterlo a fuoco.",
                    "Cambia il respiro, aumenta la tensione, lo stomaco si chiude, il cuore accelera e solo dopo arrivano i pensieri che cercano di dare un significato a quelle sensazioni.",
                    "Il passaggio è molto veloce e per questo spesso ce ne accorgiamo quando siamo già dentro la reazione. Sentiamo qualcosa, interpretiamo quello che sta accadendo e ci viene spontaneo fare qualcosa per ridurre quella sensazione.",
                    "Prendere consapevolezza del meccanismo serve a riconoscere proprio questo passaggio. Imparare a dire \"sto sentendo qualcosa\" prima di arrivare a \"devo fare qualcosa\", crea uno spazio piccolo, ma importante.",
                    "Quello spazio può aiutarci a capire meglio cosa stiamo provando, quale significato stiamo dando a quello che accade e quale risposta vogliamo realmente dare.",
                    "Anche questo significa conoscersi: imparare ad ascoltare il corpo, dare un nome alle emozioni e comprendere ciò che accade dentro di noi prima che diventi automaticamente un comportamento.",
                    "Questo è uno dei temi che attraversano il mio libro \"Prima di Pensare. Perché facciamo cose che non volevamo fare\".",
                    "Ne parleremo giovedì 8 ottobre al Centro Nitti di Melfi, durante la presentazione del libro #primadipensare.",
                    "Per chi potrà sarà un piacere salutarvi.",
                ],
            },
        ],
    },
    {
        slug: "un-lavoro-silenzioso",
        title: "Un lavoro silenzioso",
        description: 'Ci sono idee che restano dentro per anni e prendono forma in silenzio. Il racconto della firma del contratto editoriale del mio primo libro, "Prima di pensare".',
        category: 'Dal libro "Prima di pensare"',
        date: "2026-09-30",
        image: "/images/07-lavoro-silenzioso.jpg",
        imageAlt: "Scrivania in penombra con quaderno, penna e tazza, illuminata da luce calda — articolo sulla scrittura del libro Prima di pensare",
        bookPromo: true,
        quote: {
            text: "Ogni cammino importante inizia molto prima del primo passo visibile.",
            author: "David Whyte",
        },
        sections: [
            {
                subtitle: null,
                paragraphs: [
                    "Ci sono idee che restano dentro per anni, si muovono lentamente, attraversano esperienze, incontri, lavoro quotidiano e continuano a prendere forma quasi in silenzio.",
                    "A volte ci si accorge che qualcosa sta diventando concreto solo quando arriva un momento preciso, semplice ma capace di dare realtà a tutto il percorso fatto fino a quel momento.",
                ],
            },
            {
                subtitle: "Il mio primo libro",
                paragraphs: [
                    "In questi giorni sto firmando il contratto editoriale del mio primo libro.",
                    "Il mio primo libro... finalmente.",
                ],
            },
            {
                subtitle: "Un percorso nato nel tempo",
                paragraphs: [
                    "Un lavoro nato nel tempo, attraverso la formazione continua, l'osservazione del modo in cui pensiamo, dei motivi per cui reagiamo, scegliamo oppure ci allontaniamo da alcune parti di noi e poi proviamo lentamente a ritrovarle.",
                    "Il percorso fatto in questi anni mi ha aiutato a osservare meglio quei passaggi che spesso viviamo in automatico e che nel tempo iniziano a orientare il nostro modo di stare nelle esperienze.",
                ],
            },
            {
                subtitle: "Cosa succederà nei prossimi mesi",
                paragraphs: [
                    "Nei prossimi mesi questo percorso prenderà una forma ancora più concreta.",
                    "L'uscita ufficiale sarà tra novembre e dicembre sui canali editoriali, ma nei prossimi mesi inizierò a condividere alcuni passaggi, riflessioni e temi nati proprio da questo lavoro.",
                ],
            },
        ],
    },
    {
        slug: "il-coraggio-di-restare",
        title: "Il coraggio di restare: quando essere forti significa smettere di trattenere",
        description: "Stringi i denti, non piangere, passa presto: molti crescono pensando che sentire troppo sia una debolezza. Perché evitare le emozioni stanca, e cosa significa davvero essere forti.",
        category: "Emozioni e consapevolezza",
        date: "2026-09-30",
        image: "/images/08-coraggio-restare.jpg",
        imageAlt: "Uomo seduto su una piattaforma di roccia sospesa davanti a una porta socchiusa da cui entra luce — illustrazione sul coraggio di restare nelle emozioni",
        quote: {
            text: "Ciò che neghi ti sottomette, ciò che accetti ti trasforma.",
            author: "Carl Gustav Jung",
        },
        sections: [
            {
                subtitle: null,
                paragraphs: [
                    "Molte persone pensano che essere forti significhi reggere, andare avanti, non fermarsi, non farsi toccare troppo da quello che accade.",
                ],
            },
            {
                subtitle: "Quando sentire diventa una debolezza",
                paragraphs: [
                    "Lo imparano presto, sin da bambini: si sentono ripetere stringi i denti, non piangere, passa presto, e così crescono con l'idea che sentire troppo sia una debolezza.",
                    "E succede che a forza di non sentire iniziano a spostarsi dalla propria esperienza, non solo rispetto al dolore, ma anche rispetto alla gioia, perché le emozioni non si spengono a comando, si riducono tutte insieme.",
                    "Essere forti diventa allora controllarsi, trattenere, minimizzare, fare finta che vada tutto bene, anche quando dentro si è scossi da qualcosa che si sta muovendo forte.",
                ],
            },
            {
                subtitle: "La stanchezza di chi regge troppo",
                paragraphs: [
                    "Si osserva spesso questo passaggio: ci sono molte persone che sono capaci di reggere, ma nel tempo emerge una stanchezza profonda, perché la forza usata per non sentire richiede molta energia.",
                ],
            },
            {
                subtitle: "Sentire non è pericoloso",
                paragraphs: [
                    "Sentire non è pericoloso, è umano: è il modo che permette di orientarsi, di capire cosa fa bene e cosa sta facendo male.",
                    "Quando si evitano le emozioni, queste non vengono eliminate, ma solo spostate, per tornare poi sotto forma di tensione, di ansia, di chiusura, di distacco dagli altri.",
                    "Prendere consapevolezza significa concedersi di sentire senza giudicarsi, senza doversi spiegare, senza dover essere sempre all'altezza di tutto e di tutti.",
                ],
            },
            {
                subtitle: "La vera forza",
                paragraphs: [
                    "La vera forza è restare presenti a quello che c'è, anche quando non è comodo, anche quando fa male, perché è lì che inizia il contatto con se stessi.",
                    "Se senti che stai reggendo troppo, prova a fermarti e ad ascoltare cosa stai sentendo, senza correggerlo.",
                    "A volte essere forti significa proprio questo: smettere di combattere contro ciò che si muove dentro.",
                ],
            },
        ],
    },
    {
        slug: "cio-che-lasciamo",
        title: "Ciò che lasciamo",
        description: "Il valore di una vita non dipende solo da ciò che costruiamo, ma da ciò che lasciamo negli altri: affetti, gesti e presenza.",
        category: "Crescita personale",
        date: "2026-09-30",
        image: "/images/cio-che-lasciamo.jpg",
        imageAlt: "Persona che attraversa un ponte sospeso verso una porta luminosa all'alba — illustrazione su ciò che lasciamo agli altri",
        quote: {
            text: "La vita di ogni uomo finisce allo stesso modo. È solo nei dettagli di come ha vissuto e di come è morto che si distingue un uomo da un altro.",
            author: "Ernest Hemingway",
        },
        sections: [
            {
                subtitle: null,
                paragraphs: [
                    "A volte mi fermo a pensare che il valore di una vita non dipenda soltanto da ciò che siamo riusciti a costruire, ma anche da ciò che siamo stati capaci di lasciare negli altri.",
                    "Spesso si pensa allo spreco come a un'occasione perduta, a un progetto rimasto incompiuto o a un obiettivo mai raggiunto. Esiste però una forma di spreco molto più silenziosa, che riguarda ciò che avremmo potuto esprimere e abbiamo trattenuto.",
                    "Un affetto rimasto senza parole, un perdono rimandato, una capacità che non abbiamo avuto il coraggio di mettere a disposizione oppure un gesto che avrebbe potuto cambiare la giornata di qualcuno e che non abbiamo fatto.",
                    "Molte volte è la paura a guidare queste scelte: quella di sbagliare, di essere giudicati, di esporsi o di rischiare una delusione. Così, senza accorgercene, iniziamo a vivere con prudenza in tutte le occasioni, anche dove la vita ci chiederebbe una maggiore presenza.",
                    "Prendere consapevolezza ci aiuta a comprendere che il tempo non si misura soltanto dagli anni che passano, ma dalla qualità di ciò che scegliamo di donare ogni giorno.",
                    "Il valore della nostra vita non si misura da quello che riusciamo ad accumulare, ma da quello che, attraverso la nostra presenza, lasciamo nella vita degli altri.",
                    "Ciò che doniamo continua a esistere anche quando il momento è passato.",
                ],
            },
        ],
    },
    {
        slug: "ansia-quando-il-corpo-parla",
        title: "Ansia: quando il corpo parla prima di te",
        description: "Fiato corto, stomaco chiuso, spalle rigide: a volte l'ansia arriva prima di riuscire a darle un nome. Come ascoltare i segnali del corpo senza spaventarsi.",
        category: "Ansia e attacchi di panico",
        date: "2026-09-30",
        image: "/images/01-ansia.jpg",
        imageAlt: "Persona seduta di spalle davanti a un tramonto, con la propria silhouette trasparente che guarda l'orizzonte — illustrazione sull'ansia",
        quote: {
            text: "Il corpo è la prima casa dell'anima.",
            author: "Anonimo",
        },
        sections: [
            {
                subtitle: "Un allarme che non sai cosa segnala",
                paragraphs: [
                    "Spesso in studio mi capita di sentire: \"Dottore, mi sento agitato, ma non capisco perché, eppure non sto pensando a nulla di particolare\".",
                    "Questa, in realtà, è una situazione abbastanza comune: a volte l'ansia arriva prima ancora che riusciamo a darle un nome e la prima cosa che sentiamo è il corpo.",
                    "Magari stiamo facendo qualcosa di normale, niente di particolare, eppure sentiamo che qualcosa si è acceso dentro di noi, come un allarme che non sai bene cosa stia segnalando.",
                    "In quei momenti viene spontaneo cercare subito una spiegazione: cerchiamo di capire da dove arrivi quella sensazione e vogliamo trovare un modo per farla passare subito.",
                ],
            },
            {
                subtitle: "Quando l'ansia diventa familiare",
                paragraphs: [
                    "A volte l'ansia si presenta in un momento preciso e possiamo collegarla a qualcosa che sta accadendo.",
                    "Altre volte è lì da molto tempo, e diventa una presenza quasi abituale che sembra comparire anche quando non riusciamo a individuare una causa precisa.",
                    "In questi casi il corpo può aver imparato a vivere in uno stato di allerta che nel tempo diventa familiare.",
                ],
            },
            {
                subtitle: "I segnali del corpo",
                paragraphs: [
                    "Allora il corpo prende la parola, con il fiato corto, lo stomaco chiuso, le spalle rigide: sono segnali che possono dirci che qualcosa dentro di noi merita attenzione.",
                    "Il problema è che quando l'ansia passa dal corpo, può spaventarci ancora di più e ci sembra di perdere il controllo.",
                    "E allora iniziamo a combattere quella sensazione, a irrigidirci e a chiederci cosa ci stia succedendo.",
                ],
            },
            {
                subtitle: "Cosa lavoriamo in terapia",
                paragraphs: [
                    "In terapia lavoriamo molto su imparare a leggere i segnali corporei senza interpretarli subito come qualcosa di pericoloso.",
                    "Pertanto può essere utile fermarsi e chiedersi: \"Che cosa sta succedendo dentro di me in questo momento?\", così che il corpo possa diventare una fonte di informazioni su quello che stiamo vivendo.",
                    "Prendere consapevolezza ci aiuta a spostare lo sguardo: infatti quando smettiamo di alimentare la lotta contro quella sensazione e iniziamo a starci dentro con maggiore attenzione, qualcosa cambia, l'ansia cambia.",
                ],
            },
            {
                subtitle: "Ascoltare senza fuggire",
                paragraphs: [
                    "Rallentare il respiro, concedersi una pausa e riconoscere quello che sentiamo può già modificare il modo in cui viviamo quel momento.",
                    "Se senti che il corpo sta parlando forte, prova a fermarti un attimo, fai un respiro lento, metti una mano sul petto e prova a darti qualche secondo di attenzione: questo può aiutarti a capire cosa sta succedendo.",
                    "Non aggiustare tutto subito, ascolta senza fuggire.",
                ],
            },
        ],
    },
    {
        slug: "capire-prima-di-agire",
        title: "Capire prima di agire",
        description: "Una parola, un gesto, una risposta: a volte reagiamo prima ancora di aver deciso. Come creare uno spazio tra ciò che sentiamo e ciò che facciamo.",
        category: "Emozioni e consapevolezza",
        date: "2026-09-30",
        image: "/images/02-capire.jpg",
        imageAlt: "Scultura di un volto pensoso con figure intrecciate nella mente e un uomo che cammina verso la luce — illustrazione su comprendere prima di agire",
        quote: {
            text: "Conoscere se stessi è l'inizio della saggezza.",
            author: "Socrate",
        },
        sections: [
            {
                subtitle: "Quando reagiamo in automatico",
                paragraphs: [
                    "A volte facciamo qualcosa prima ancora di aver deciso di farla: una parola, un gesto, una risposta possono arrivare in modo quasi automatico, seguendo un'abitudine, un'emozione o un modo impulsivo di reagire.",
                    "Dentro di noi esistono processi che si attivano rapidamente e orientano il comportamento prima che il pensiero abbia il tempo di intervenire.",
                    "Può accadere quando una persona ci parla con un certo tono e sentiamo subito il bisogno di difenderci, oppure quando una situazione ci mette in allarme e reagiamo ancora prima di aver compreso cosa stia realmente accadendo.",
                    "In quei momenti la reazione può sembrare naturale e immediata, quasi fosse l'unico modo possibile di rispondere.",
                ],
            },
            {
                subtitle: "Lo spazio tra ciò che sentiamo e ciò che facciamo",
                paragraphs: [
                    "Prendere consapevolezza di questo meccanismo ci aiuta a creare uno spazio tra ciò che sentiamo e ciò che facciamo.",
                    "Fermarsi qualche istante ci permette così di osservare cosa si è attivato dentro di noi, quale significato stiamo dando a ciò che accade e cosa sta guidando il nostro comportamento.",
                    "In quello spazio possiamo riconoscere le emozioni e ascoltare i pensieri, prima di trasformarli in una risposta.",
                ],
            },
            {
                subtitle: "Scegliere una risposta",
                paragraphs: [
                    "Alcune nostre azioni diventano più chiare se osserviamo cosa succede dentro di noi prima di scegliere.",
                    "Possiamo fermarci, capire cosa sta accadendo e scegliere una risposta più vicina a ciò che sentiamo e vogliamo.",
                ],
            },
        ],
    },
    {
        slug: "prima-di-iniziare-procrastinazione",
        title: "Prima di iniziare: perché rimandiamo ciò che sappiamo di dover fare",
        description: "La visita rimandata, il progetto fermo da settimane: dietro la procrastinazione spesso non c'è pigrizia, ma l'emozione che associamo a ciò che dobbiamo fare.",
        category: "Crescita personale",
        date: "2026-09-30",
        image: "/images/03-prima-di-iniziare.jpg",
        imageAlt: "Uomo che cammina su una scalinata verso una porta di luce trascinando una grande palla al piede — illustrazione sulla procrastinazione",
        quote: {
            text: "Un viaggio di mille miglia comincia con un singolo passo.",
            author: "Lao Tzu",
        },
        sections: [
            {
                subtitle: "Non è solo pigrizia",
                paragraphs: [
                    "Quante volte sappiamo perfettamente cosa dovremmo fare e, proprio quando arriva il momento di farlo, troviamo un motivo per rimandare?",
                    "La visita che continuiamo a spostare. Quel progetto che aspetta da settimane. Una decisione che conosciamo già, ma che continuiamo a rinviare.",
                    "A volte pensiamo che sia pigrizia, altre volte ci diciamo di avere poca forza di volontà.",
                    "In realtà, dietro la procrastinazione, a volte, può esserci qualcosa di diverso, come l'emozione che associamo a ciò che dobbiamo fare.",
                ],
            },
            {
                subtitle: "Quando un compito diventa una prova",
                paragraphs: [
                    "È così che un compito può diventare molto più grande nella nostra mente di quanto lo sia nella realtà.",
                    "E succede che scrivere una pagina può trasformarsi nel bisogno di dimostrare di essere capaci. Preparare una presentazione può diventare la prova del nostro valore professionale. Iniziare un progetto può significare, nella nostra mente, scoprire se siamo davvero all'altezza.",
                    "A quel punto non stiamo più evitando il compito, ma stiamo cercando di evitare ciò che quel compito potrebbe farci sentire.",
                ],
            },
            {
                subtitle: "Ridurre il peso del primo passo",
                paragraphs: [
                    "Prendere consapevolezza di questo meccanismo ci aiuta a ridurre la distanza tra ciò che sappiamo di dover fare e ciò che riusciamo realmente a fare.",
                    "La soluzione spesso non è aumentare la pressione, ma ridurre il peso che abbiamo messo su quel primo passo.",
                    "Non dobbiamo finire tutto oggi, ma dobbiamo iniziare: una pagina. Una telefonata. Iniziamo con dieci minuti al giorno e poi il resto verrà da sé.",
                    "Quando smettiamo di trasformare ogni azione in un giudizio su noi stessi, diventa più facile agire: il passo più difficile non è fare ciò che dobbiamo fare, ma smettere di chiedere a quel gesto di dimostrare quanto valiamo.",
                ],
            },
        ],
    },
    {
        slug: "il-se-di-domani",
        title: "Il sé di domani",
        description: "Rimandare, mantenere cattive abitudini, comportarci come se la persona che saremo domani fosse un'altra: come le piccole scelte di oggi costruiscono chi saremo.",
        category: "Crescita personale",
        date: "2026-09-30",
        image: "/images/05-se-di-domani.jpg",
        imageAlt: "Un bambino, un ragazzo e un uomo in piedi su cubi di altezza crescente davanti a un percorso illuminato dal sole — illustrazione sulla persona che diventeremo",
        quote: {
            text: "Il futuro dipende da ciò che fai oggi.",
            author: "Mahatma Gandhi",
        },
        sections: [
            {
                subtitle: "Quando le cattive abitudini sembrano la strada più logica",
                paragraphs: [
                    "A volte penso a quanta mancanza di consapevolezza abbiamo nei nostri confronti: spesso rispondiamo ad automatismi inconsci e ci comportiamo come se la persona che saremo domani fosse un'altra persona.",
                    "Sicuramente capita a tutti di far tardi la sera, di rimandare quello che sappiamo di dover fare, di saltare qualche appuntamento importante, ma un conto è farlo se capita e un altro è continuare a mantenere cattive abitudini, le quali ci appaiono come la scelta della strada più logica.",
                    "Poi arriva il giorno dopo e quel problema che avevamo deciso di lasciare più avanti torna a presentarsi, normalmente facendo passare in secondo piano il fatto che a pagarne il prezzo siamo sempre e solo noi.",
                ],
            },
            {
                subtitle: "Le piccole scelte che costruiscono la direzione",
                paragraphs: [
                    "Spesso si pensa che le grandi svolte della vita dipendano da decisioni importanti, ma molte volte la direzione si costruisce attraverso scelte piccole e ripetute nel tempo.",
                    "Una passeggiata fatta oppure rimandata, un esame preparato oppure evitato, una parola trattenuta oppure detta, un'abitudine mantenuta oppure abbandonata.",
                    "Ogni scelta lascia qualcosa alla persona che saremo domani, tra qualche settimana, tra qualche anno o tra qualche decennio.",
                ],
            },
            {
                subtitle: "Presente e futuro sono la stessa storia",
                paragraphs: [
                    "Prendere consapevolezza ci aiuta a ricordare che il presente e il futuro non sono separati, ma la stessa storia osservata in momenti diversi.",
                    "Pertanto iniziamo a imparare a trattare con rispetto la persona che un giorno raccoglierà ciò che oggi stiamo seminando.",
                ],
            },
        ],
    },
    {
        slug: "abbi-cura-di-te",
        title: "Abbi cura di te",
        description: "Prendersi cura di sé non è solo riposo e tempo libero: riguarda il modo in cui ci trattiamo ogni giorno, i nostri limiti, le emozioni e i pensieri che alimentiamo.",
        category: "Emozioni e consapevolezza",
        date: "2026-09-30",
        image: "/images/06-abbi-cura.jpg",
        imageAlt: "Maschera sospesa e rosa che fiorisce vicino a un lago al tramonto — illustrazione sull'avere cura di sé",
        quote: {
            text: "È il tempo che hai perduto per la tua rosa che ha reso la tua rosa così importante.",
            author: "Antoine de Saint-Exupéry, Il Piccolo Principe",
        },
        sections: [
            {
                subtitle: "Cosa significa davvero avere cura di sé",
                paragraphs: [
                    "Spesso pensiamo che prendersi cura di sé stessi abbia a che fare con il tempo libero, con il riposo o con il concedersi qualcosa di piacevole.",
                    "Sicuramente sono elementi importanti di cui dobbiamo tener conto, ma in realtà riguarda anche il modo in cui ci trattiamo ogni giorno, il tempo che diamo alle nostre emozioni, la qualità dei pensieri che alimentiamo e magari anche la capacità di ascoltare quello che stiamo vivendo.",
                    "Avere cura di sé significa imparare a riconoscere i propri limiti, a dare spazio alla stanchezza quando si presenta, a rispettare i propri tempi e sviluppare un rapporto più attento con ciò che sentiamo.",
                    "Dentro la quotidianità, anche piccoli gesti di attenzione verso sé stessi possono creare maggiore equilibrio e presenza.",
                ],
            },
            {
                subtitle: "Quando ci mettiamo in secondo piano",
                paragraphs: [
                    "Invece, sempre più spesso succede che ci mettiamo in secondo piano: magari non ce ne accorgiamo proprio delle richieste silenziose della nostra mente.",
                    "Per cui prendere consapevolezza ci aiuta a osservare meglio il modo in cui attraversiamo le giornate, il modo in cui ci parliamo interiormente e il peso che diamo a ciò che accade.",
                ],
            },
            {
                subtitle: "Le risorse che già possediamo",
                paragraphs: [
                    "Questa maggiore consapevolezza ci aiuta anche a riconoscere le risorse che possediamo, la capacità di adattarci alle difficoltà e la possibilità di costruire risposte più coerenti con i nostri bisogni e valori.",
                    "Con il tempo, prendersi cura di sé diventa una forma di stabilità interiore, dove cresce la capacità di stare nelle esperienze con maggiore continuità, permettendoci di attraversare i momenti complessi con più presenza e di dare valore a ciò che sostiene il proprio equilibrio emotivo.",
                ],
            },
        ],
    },
    {
        slug: "senso-di-colpa-non-ti-lascia-in-pace",
        title: "Quando il senso di colpa non ti lascia in pace",
        description: 'Da dove nasce il senso di colpa, come distinguerlo da quello "sano" e perché a volte non parla del presente.',
        category: "Emozioni e consapevolezza",
        date: "2026-09-23",
        image: "/images/senso-di-colpa.jpg",
        imageAlt: "Una donna affacciata alla finestra al tramonto, pensierosa — articolo sul senso di colpa",
        quote: {
            text: "Il senso di colpa è una prigione invisibile.",
            author: "Anonimo",
        },
        sections: [
            {
                subtitle: "Una sensazione difficile da riconoscere",
                paragraphs: [
                    "Spesso mi succede di incontrare persone che sentono qualcosa dentro, ma senza capire bene cosa sia e da dove arrivi. È una sensazione che, piano piano, imparano a riconoscere come senso di colpa, anche se continuano a non capirne il motivo.",
                    "Il senso di colpa, infatti, non sempre si presenta in modo evidente: a volte rimane sotto traccia, altre in sottofondo, e continua a farsi sentire anche quando apparentemente tutto sembra andare bene.",
                ],
            },
            {
                subtitle: "Quando il senso di colpa diventa cronico",
                paragraphs: [
                    "Il senso di colpa può nascere più spesso di ciò che crediamo: da una scelta, da un no detto, da un desiderio che non coincide con quello degli altri. E da quel momento in poi resta, come se dovessi continuamente giustificarti.",
                    "Molte persone convivono con il senso di colpa senza accorgersene davvero: lo scambiano per responsabilità, per coscienza, per essere persone perbene.",
                    "E invece il senso di colpa è più pericoloso di quanto potremmo pensare, perché a lungo andare diviene cronico. E questo logora, perché ci tiene in allerta, ci fa dubitare di noi stessi, ci spinge a rimediare anche quando non abbiamo fatto nulla di male.",
                    "Ti porta a spiegarti troppo, a chiedere scusa in anticipo, a rinunciare a cose importanti pur di non deludere, come se il tuo benessere dovesse sempre venire dopo.",
                ],
            },
            {
                subtitle: "Cosa emerge in terapia",
                paragraphs: [
                    "In terapia spesso emerge questo nodo: il senso di colpa non parla del presente, parla di regole interiori antiche, di aspettative assorbite, di messaggi ricevuti e mai messi in discussione.",
                    "Prendere consapevolezza aiuta a distinguere: abbiamo fatto qualcosa che va riparato, o ci stiamo solo sentendo in colpa per essere noi stessi? Sono due cose molto diverse.",
                ],
            },
            {
                subtitle: 'Il senso di colpa "sano"',
                paragraphs: [
                    'Esiste però un senso di colpa, diciamo, "sano", perché orienta. Quello eccessivo, invece, blocca: ti fa vivere con il freno tirato, come se la felicità dovesse sempre essere pagata.',
                    "Liberarsene non significa diventare egoisti, ma restituire alla colpa il suo posto giusto, senza lasciarle guidare ogni scelta.",
                ],
            },
            {
                subtitle: "Una domanda da farti",
                paragraphs: [
                    "Se senti che il senso di colpa non ti lascia in pace, prova a fermarti e a chiederti: di chi è davvero questa voce che sto ascoltando?",
                    "Avere consapevolezza delle proprie emozioni significa anche smettere di punirsi per bisogni legittimi.",
                ],
            },
        ],
    },
];

export const readingTime = (article) => {
    const words = article.sections
        .flatMap((s) => s.paragraphs)
        .join(" ")
        .split(/\s+/).length;
    return Math.max(1, Math.round(words / 200));
};

export const formatDate = (iso) =>
    new Date(iso + "T12:00:00").toLocaleDateString("it-IT", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });

export const sortedArticles = () => {
    const order = ARTICLES.map((a) => a.slug);
    return [...ARTICLES].sort((a, b) => {
        const byDate = b.date.localeCompare(a.date);
        if (byDate !== 0) return byDate;
        return order.indexOf(a.slug) - order.indexOf(b.slug);
    });
};
